module.exports = __webpack_public_path__ + "img/dep_produce.67d61db7.png";